import { createSelector } from 'reselect'
import { get, partialRight } from 'lodash'

const selectFromHomeInsuranceData = path =>
  createSelector(
    state => state.homeInsurance.data,
    partialRight(get, path)
  )

export const selectShowDetail = createSelector(
  state => state.homeInsurance,
  partialRight(get, 'showDetail')
)

export const selectLoading = selectFromHomeInsuranceData('loading')
export const selectEnabled = selectFromHomeInsuranceData('enabled')
export const selectDaysUntilRenewal = selectFromHomeInsuranceData(
  'daysUntilRenewal'
)
export const selectYearsSincePurchase = selectFromHomeInsuranceData(
  'yearsSincePurchase'
)
export const selectEstimatedValue = selectFromHomeInsuranceData(
  'estimatedValue'
)
